export default __webpack_public_path__ + "static/media/logo_emv.24550c99.svg";